import React from 'react';
import styled from 'styled-components';

const OnlineDot = styled.div`
  width: 10px;
  height: 10px;
  background-color: #44B700;
  border-radius: 50%;
`;

export default React.memo(OnlineDot);
